/* eslint no-var: 0 */
var main = require('./dist/commonjs/index.js').default;

module.exports = main;
module.exports.default = main;



//////////////////
// WEBPACK FOOTER
// ./~/i18next-browser-languagedetector/index.js
// module id = 1989
// module chunks = 0